module.exports = __webpack_public_path__ + "static/img/test3.e774afb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/test3.jpg
// module id = Zltz
// module chunks = 25